import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetPublicEventShareLinkResult {
  shareToken: string | null;
}

export const getPublicEventShareLinkAPI = async (eventId: string) => {
  const response = await baseAPI.get<GetPublicEventShareLinkResult>(
    `/events/${eventId}/public-share-link`,
  );
  return response.data;
};

export function useGetPublicEventShareLink(eventId: string) {
  return useQuery({
    queryKey: [KEYS.EVENTS, eventId, 'public-share-link'],
    queryFn: () => getPublicEventShareLinkAPI(eventId),
    enabled: eventId.trim().length > 0,
  });
}
